import { render } from "./AboutMe.vue?vue&type=template&id=00a03556"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=00a03556&lang=postcss"

import exportComponent from "F:\\Projects_BE\\lakshitha1629.github.io\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__